import Vue from 'vue';
import DealerMap from '../vue/DealerMap.vue';

if(document.getElementById('dealers__map')){
	new Vue({
		el: '#dealers__map',
		components: {
			'dealer-map': DealerMap
		}
		// components: { DealerMap }
	})
}